import React, { PropsWithChildren, useCallback, useState } from "react";
import { Notification, NotificationContext } from "./NotificationContext";

export const NotificationContextProvider = (props: PropsWithChildren) => {
  const [notification, setNotification] = useState<Notification>();
  const [notificationError, setNotificationError] = useState<Notification>();

  const sendNotification = useCallback(
    (text: string, autoHideDuration = 6000) => {
      setNotification({ text, autoHideDuration });
    },
    [setNotification]
  );

  const sendNotificationError = useCallback(
    (text: string, autoHideDuration = 10000) => {
      setNotificationError({ text, autoHideDuration });
    },
    [setNotificationError]
  );

  return (
    <NotificationContext.Provider value={{ notification, notificationError, sendNotification, sendNotificationError }}>
      {props.children}
    </NotificationContext.Provider>
  );
};
